.form {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-8);
  height: 44px;
  padding: var(--zumpo-space-6) var(--zumpo-space-8) var(--zumpo-space-6)
    var(--zumpo-space-14);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-12);
  background: var(--zumpo-paper);
}

.form:focus-within {
  border-color: var(--zumpo-ink);
  box-shadow: inset 0 0 0 1px var(--zumpo-ink);
}

.input {
  flex: 1;
  min-width: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--zumpo-ink);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  outline: none;
}

.input::placeholder {
  color: var(--zumpo-muted);
  opacity: 1;
}

/* Phones zoom into any input under 16 px when it takes focus. */
@media (pointer: coarse) {
  .input {
    font: var(--zumpo-text-body);
  }
}

.send {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-8);
  background: var(--zumpo-coral);
  color: var(--zumpo-ink);
  cursor: pointer;
  touch-action: manipulation;
}

/* The button keeps Figma's 28 px, but a tap lands anywhere in the 44 px
   around it, the size a thumb needs. */
.send::before {
  content: '';
  position: absolute;
  inset: calc(-1 * var(--zumpo-space-8));
}

@media (hover: hover) {
  .send:hover {
    box-shadow: inset 0 0 0 2px var(--zumpo-ink);
  }
}

.send:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.arrow {
  transform: rotate(180deg);
}

.locked {
  background: var(--zumpo-sand);
  color: var(--zumpo-muted);
}

.locked .input {
  cursor: not-allowed;
}
